import React from 'react';
import { Badge } from '@odin-labs/components';
import { AnnouncementInput, announcementStatusColor } from './constants';

export function AnnouncementStatusBadge(
  props: AnnouncementInput,
): React.ReactElement {
  const { announcement } = props;
  return (
    <Badge
      text={announcement?.status}
      color={announcementStatusColor[announcement?.status]}
      size="lg"
    />
  );
}
